import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { extractNumberFromQueryKeyPart } from "@/3514/utils"

import { EDiagnosticSummaryQueryKey as EKey, EDiagnosticSummaryQueryUrl as EUrl } from "./diagnostic-summary.api.config"
import type { IDiagnosticSummaryQueryDto as IDto } from "./diagnostic-summary.api.types"

export default async function ({ queryKey }: QueryFunctionContext<ReturnType<typeof EKey>>): Promise<IDto> {
    const { data }: AxiosResponse<IDto> = await axiosClient.get<IDto>(
        EUrl({ participantId: extractNumberFromQueryKeyPart(queryKey[1]) })
    )

    return data
}
